import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableSecurityPage = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableSecurityPage);
};
